import React, { useContext, useEffect, useState } from "react";
import { useFormik, validateYupSchema } from "formik";
import * as Yup from "yup";
import moment from "moment";
import styled from "styled-components";
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  LinearProgress,
  FormHelperText,
} from "@material-ui/core";
import { Button } from "../ui/forms/Button";
import ClearIcon from "@material-ui/icons/Clear";
import SaveIcon from "@material-ui/icons/Save";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { PatronContext } from "../../contexts/PatronContext";
import { UserContext } from "../../contexts/UserContext";
import { PaneContext } from "../../contexts/PaneContext";
import { useSnackbar } from "notistack";

const Details = () => {
  const {
    patron,
    selectPatron,
    handlePatronChange,
    updatePatron,
    createPatron,
  } = useContext(PatronContext);
  const { enqueueSnackbar } = useSnackbar();
  const { Site, email } = useContext(UserContext);
  const {
    siteType,
    custom1,
    custom1Enabled,
    custom2,
    custom2Enabled,
    custom3,
    custom3Enabled,
    custom1Length,
    custom2Length,
    custom3Length,
  } = Site;
  const { newPatronMode, toggleNewPatronMode, changeTab } =
    useContext(PaneContext);
  const [DisExt, setDisExt] = useState(patron.DisExt);

  const patronLabel =
    siteType === 0 || Site.siteType === 5 ? "Student" : "Staff";

  const smartRiderInit = {
    lastName: patron.lastName || "",
    firstName: patron.firstName || "",
    street: patron.street || "",
    suburb: patron.suburb || "",
    state: patron.state || "WA",
    postcode: patron.postcode || "",
    externalID: patron.externalID || "",
    yearGroup: patron.yearGroup || 0,
    dateOfBirth: patron.dateOfBirth || "",
    curriculum: patron.curriculum || "",
    custom1: patron.custom1 || "",
    custom2: patron.custom2 || "",
    custom3: patron.custom3 || "",
    userEmail: patron.userEmail || "",
  };

  const idInit = {
    lastName: patron.lastName || "",
    firstName: patron.firstName || "",
    externalID: patron.externalID || "",
    dateOfBirth: patron.dateOfBirth || moment(Date.now()).format("YYYY-MM-DD"),
    custom1: patron.custom1 || "",
    custom2: patron.custom2 || "",
    custom3: patron.custom3 || "",
    userEmail: patron.userEmail || "",
  };

  const smartRiderValidation = {
    lastName: Yup.string().required("Lastname is a Required Field"),
    firstName: Yup.string().required("Firstname is a Required Field"),
    street: Yup.string().required("Street is a Required Field"),
    suburb: Yup.string().required("Suburb is a Required Field"),
    state: Yup.string().required("State is a Required Field"),
    postcode: Yup.string().max(4, "Must be 4 characters").required("Required"),
    externalID: Yup.string().required("External ID is a Required Field"),
    yearGroup: Yup.number().nullable(),
    dateOfBirth: Yup.date().required("Date of Birth is a Required Field"),
    curriculum: Yup.string().nullable(),
    custom1: Yup.string().nullable(),
    custom2: Yup.string().nullable(),
    custom3: Yup.string().nullable(),
    userEmail: Yup.string().nullable(),
  };

  const idValidation = {
    lastName: Yup.string().required("Required"),
    firstName: Yup.string().required("Required"),
    externalID: Yup.string().when("siteType", {
      is: (value) => siteType === 2 || siteType === 3,
      then: () =>
        Yup.string()
          .required("Must be Number")
          .matches(/^[0-9\b]+$/),
    }),
    dateOfBirth: Yup.date().nullable(),
    custom1: Yup.string().nullable(),
    custom2: Yup.string().nullable(),
    custom3: Yup.string().nullable(),
    userEmail: Yup.string().nullable(),
  };

  const formik = useFormik({
    initialValues: patron
      ? patron
      : siteType === 0 || siteType === 5
      ? smartRiderInit
      : idInit,
    validationSchema: Yup.object(
      siteType === 0 || siteType === 5 ? smartRiderValidation : idValidation
    ),
    onSubmit: (values, { setSubmitting }) => {
      formik.values.state = formik.values.state.trim();

      if (formik.errors) {
        console.log("postcode");
      }

      var DOBOK = false;

      formik.values.externalID = formik.values.externalID.replace(/ /g, "");

      formik.values.userEmail = email;

      if (newPatronMode === true) {
        if (
          siteType === 1 ||
          siteType === 2 ||
          siteType === 3 ||
          siteType === 4 ||
          siteType === 6
        ) {
          DOBOK = true;
          formik.values.dateOfBirth = "1900-01-01"; // default value to handle date of birth field
        } else {
          var date = new Date();
          var d =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate();

          const et = moment(formik.values.dateOfBirth);
          const st = moment(date);

          const diffDuration = moment.duration(st.diff(et));

          const diffYrs = diffDuration.years();
          const diffMonth = diffDuration.months();

          if (diffYrs > 3) {
            formik.values.dateOfBirth = formik.values.dateOfBirth;
            DOBOK = true;
          } else {
            formik.values.dateOfBirth = null;
            window.alert("minimum age is 4 years");
          }
        }
      }
      if (DOBOK === true) {
        createPatron(values)
          .then((createdPatron) => {
            selectPatron(createdPatron);
            setSubmitting(false);
          })
          .catch((err) => console.log(err));
      } else {
        if (
          siteType === 1 ||
          siteType === 2 ||
          siteType === 3 ||
          siteType === 4 ||
          siteType === 6
        ) {
          DOBOK = true;
          formik.values.dateOfBirth = "01-01-1900"; // default value to handle date of birth field
        } else {
          var date = new Date();
          var d =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getDate();

          const et = moment(formik.values.dateOfBirth);
          const st = moment(date);

          const diffDuration = moment.duration(st.diff(et));

          const diffYrs = diffDuration.years();
          const diffMonth = diffDuration.months();

          if (diffYrs > 3) {
            formik.values.dateOfBirth = formik.values.dateOfBirth;
            DOBOK = true;
          } else {
            formik.values.dateOfBirth = null;
            window.alert("minimum age is 4 years");
          }
        }
      }
      if (DOBOK === true && newPatronMode === false) {
        updatePatron(values.externalID, values);
      }
      setSubmitting(false);
    },
  });

  const Clear = async () => {
    formik.handleReset();
    formik.setValues(siteType === 0 ? smartRiderInit : idInit);
  };

  const moveToPhotos = async () => {
    if (
      siteType === 1 ||
      siteType === 2 ||
      siteType === 3 ||
      siteType === 4 ||
      siteType === 6
    ) {
      formik.values.dateOfBirth = "01-01-1900";
    }

    formik.validateForm().then(async (errors) => {
      const possibleErrors = Object.keys(errors);
      if (possibleErrors.length === 0) {
        const newPatron = await createPatron(formik.values);
        toggleNewPatronMode(false);
        changeTab(1);
        selectPatron(JSON.parse(newPatron.data)[0]);
      } else {
        enqueueSnackbar(`${possibleErrors} fails data validation`, {
          variant: "error",
          autoHideDuration: 6000,
        });
      }
    });
  };

  useEffect(() => {
    if (patron.PatronID) formik.setValues(patron);
    if (newPatronMode) formik.setValues(smartRiderInit);

    //eslint-disable-next-line
  }, [patron]);

  var A = moment(patron.updatedAt)
    .subtract(8, "hours")
    .format("dddd, MMMM Do YYYY, h:mm:ss a");

  if (patron.externalID != undefined) {
    var ext = patron.externalID;
    var SliceExt = ext.slice(0, 10);
    if (SliceExt === "NotDefined" && DisExt == true) {
      setDisExt(false);
    }
  }

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            name="lastName"
            label="Surname"
            value={formik.values.lastName}
            onChange={(e) => {
              formik.handleChange(e);
              handlePatronChange(e);
            }}
            onBlur={formik.handleBlur}
            helperText={
              formik.errors.lastName &&
              formik.touched.lastName &&
              formik.errors.lastName
            }
            InputLabelProps={{ shrink: true }}
            required
            inputProps={{ style: { textTransform: "capitalize" } }}
          />
          <TextField
            name="firstName"
            label="First Name/s"
            value={formik.values.firstName}
            onChange={(e) => {
              formik.handleChange(e);
              handlePatronChange(e);
            }}
            onBlur={formik.handleBlur}
            helperText={
              formik.errors.firstName &&
              formik.touched.firstName &&
              formik.errors.firstName
            }
            InputLabelProps={{ shrink: true }}
            required
            inputProps={{ style: { textTransform: "capitalize" } }}
          />
          {(newPatronMode && siteType === 0) ||
          (newPatronMode && siteType === 6) ||
          (newPatronMode && siteType === 5) ||
          (Site.showAddress && siteType === 0) ||
          (Site.showAddress && siteType === 5) ||
          (Site.showAddress && siteType === 6) ? (
            <>
              <TextField
                name="street"
                label="Street Address"
                value={formik.values.street}
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePatronChange(e);
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.errors.street &&
                  formik.touched.street &&
                  formik.errors.street
                }
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{ style: { textTransform: "capitalize" } }}
              />
              <TextField
                name="suburb"
                label="Suburb"
                value={formik.values.suburb}
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePatronChange(e);
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.errors.suburb &&
                  formik.touched.suburb &&
                  formik.errors.suburb
                }
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{ style: { textTransform: "capitalize" } }}
              />
              <Grid container spacing={2}>
                <Grid item md={6}>
                  <FormControl>
                    <InputLabel htmlFor="state">State</InputLabel>
                    <Select
                      name="state"
                      // label='state'
                      // labelId='state'
                      // inputProps={{
                      //   id: 'state',
                      // }}
                      value={formik.values.state}
                      defaultValue={"WA"}
                      onChange={(e) => {
                        formik.handleChange(e);
                        handlePatronChange(e);
                      }}
                      onBlur={formik.handleBlur}
                    >
                      <MenuItem value="WA">WA</MenuItem>
                      <MenuItem value="NSW">NSW</MenuItem>
                      <MenuItem value="VIC">VIC</MenuItem>
                      <MenuItem value="SA">SA</MenuItem>
                      <MenuItem value="ACT">ACT</MenuItem>
                      <MenuItem value="QLD">QLD</MenuItem>
                      <MenuItem value="NT">NT</MenuItem>
                    </Select>

                    {formik.errors.state && formik.touched.state && (
                      <FormHelperText>{formik.errors.state}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <TextField
                    type="number"
                    name="postcode"
                    label="Postcode"
                    value={formik.values.postcode}
                    onChange={(e) => {
                      formik.handleChange(e);
                      handlePatronChange(e);
                    }}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.errors.postcode &&
                      formik.touched.postcode &&
                      formik.errors.postcode
                    }
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </Grid>
              </Grid>
            </>
          ) : (
            <></>
          )}
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item md={siteType === 0 || siteType === 5 ? 6 : 12}>
              <TextField
                name="externalID"
                label={`${patronLabel} ID`}
                value={formik.values.externalID}
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePatronChange(e);
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.errors.externalID &&
                  formik.touched.externalID &&
                  formik.errors.externalID
                }
                disabled={DisExt == false || newPatronMode ? false : true}
                InputLabelProps={{ shrink: true }}
                required
              />
            </Grid>
            {siteType === 0 || siteType === 5 ? (
              <Grid item md={6}>
                <FormControl>
                  <InputLabel htmlFor="yearGroup">Year Group</InputLabel>
                  <Select
                    name="yearGroup"
                    label="Year Group"
                    labelId="yearGroup"
                    inputProps={{
                      id: "yearGroup",
                    }}
                    value={formik.values.yearGroup}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => {
                      formik.handleChange(e);
                      handlePatronChange(e);
                    }}
                    onBlur={formik.handleBlur}
                  >
                    <MenuItem value={0}>N/A</MenuItem>
                    <MenuItem value={15}>Pre-Kindy</MenuItem>
                    <MenuItem value={13}>Kindergarten</MenuItem>
                    <MenuItem value={14}>Pre-Primary</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                  </Select>

                  {formik.errors.yearGroup && formik.touched.yearGroup && (
                    <FormHelperText>{formik.errors.yearGroup}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>

          {siteType === 0 || siteType === 5 ? (
            <>
              <TextField
                type="date"
                name="dateOfBirth"
                label="date Of Birth"
                placeholder="Date Of Birth"
                dateFormat="dd/MM/yyyy"
                value={formik.values.dateOfBirth}
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePatronChange(e);
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.errors.dateOfBirth &&
                  formik.touched.dateOfBirth &&
                  formik.errors.dateOfBirth
                }
                InputLabelProps={{ shrink: true }}
                required
              />
              <TextField
                name="curriculum"
                label="Curriculum"
                value={formik.values.curriculum}
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePatronChange(e);
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.errors.curriculum &&
                  formik.touched.curriculum &&
                  formik.errors.curriculum
                }
                InputLabelProps={{ shrink: true }}
              />
            </>
          ) : (
            <></>
          )}
          {custom1Enabled && (
            <TextField
              name="custom1"
              label={
                Site.custom1Length > 0
                  ? `${custom1} (Max ${Site.custom1Length} chars)`
                  : custom1
              }
              value={formik.values.custom1}
              onChange={(e) => {
                formik.handleChange(e);
                handlePatronChange(e);
              }}
              onBlur={formik.handleBlur}
              helperText={
                formik.errors.custom1 &&
                formik.touched.custom1 &&
                formik.errors.custom1
              }
              InputLabelProps={{ shrink: true }}
              onInput={(e) => {
                if (
                  e.target.value != "" &&
                  Site.custom1Length > 0 &&
                  e.target.value.length > Site.custom1Length
                ) {
                  e.target.value = e.target.value.slice(0, Site.custom1Length);
                }
              }}
            />
          )}

          {custom2Enabled && (
            <TextField
              name="custom2"
              label={
                Site.custom2Length > 0
                  ? `${custom2} (Max ${Site.custom2Length} chars)`
                  : custom2
              }
              value={formik.values.custom2}
              onChange={(e) => {
                formik.handleChange(e);
                handlePatronChange(e);
              }}
              onBlur={formik.handleBlur}
              helperText={
                formik.errors.custom2 &&
                formik.touched.custom2 &&
                formik.errors.custom2
              }
              InputLabelProps={{ shrink: true }}
              onInput={(e) => {
                if (
                  e.target.value != "" &&
                  Site.custom2Length > 0 &&
                  e.target.value.length > Site.custom2Length
                ) {
                  e.target.value = e.target.value.slice(0, Site.custom2Length);
                }
              }}
            />
          )}

          {custom3Enabled && (
            <TextField
              name="custom3"
              label={
                Site.custom3Length > 0
                  ? `${custom3} (Max ${Site.custom3Length} chars)`
                  : custom3
              }
              value={formik.values.custom3}
              onChange={(e) => {
                formik.handleChange(e);
                handlePatronChange(e);
              }}
              onBlur={formik.handleBlur}
              helperText={
                formik.errors.custom3 &&
                formik.touched.custom3 &&
                formik.errors.custom3
              }
              InputLabelProps={{ shrink: true }}
              onInput={(e) => {
                if (
                  e.target.value != "" &&
                  Site.custom3Length > 0 &&
                  e.target.value.length > Site.custom3Length
                ) {
                  e.target.value = e.target.value.slice(0, Site.custom3Length);
                }
              }}
            />
          )}
        </Grid>
      </Grid>
      {formik.isSubmitting}
      <FormActions>
        {newPatronMode && <Button onClick={Clear}>Clear</Button>}
        {!newPatronMode && (
          <text
            style={{
              marginRight: "7%",
              marginTop: "1%",
              color: "#878686",
            }}
          >
            Last Update :{" "}
            {moment(patron.updatedAt).format("dddd, MMMM Do YYYY, h:mm:ss a")}
          </text>
        )}
        {/* {!newPatronMode && localStorage.WondeID != 0 ? (
          <Button style={{ color: '#ae98ba', variant: 'outlined' }}>
            <UpdateIcon />
            Update
          </Button>
        ) : (
          <></>
        )} */}

        <Button
          colour="error"
          disabled={formik.isSubmitting}
          onClick={
            newPatronMode
              ? toggleNewPatronMode
              : () => {
                  formik.handleReset();
                  selectPatron();
                }
          }
          startIcon={<ClearIcon />}
          margin="0 1rem"
        >
          Cancel
        </Button>
        <Button
          colour="success"
          type="submit"
          startIcon={<SaveIcon />}
          margin={
            newPatronMode && formik.values.externalID ? "0 1rem 0 0" : "0"
          }
        >
          Save
        </Button>

        {newPatronMode && formik.values.externalID && (
          <Button
            colour="info"
            onClick={moveToPhotos}
            startIcon={<ArrowRightAltIcon />}
          >
            Add a Photo
          </Button>
        )}
      </FormActions>
    </Form>
  );
};

const Form = styled.form`
  padding: 0.5rem;
`;

const FormActions = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: flex-end;
`;

export default Details;
